import { render } from "./ArancelesCarrera.vue?vue&type=template&id=1087e4fc"
import script from "./ArancelesCarrera.vue?vue&type=script&lang=js"
export * from "./ArancelesCarrera.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__